import React, {useContext} from "react";
import {AuthContext} from "./auth/AuthContext";
import {LogoHp} from "@veneer/core";


const Headeraccount = () => {

    const authContext = useContext(AuthContext);
    const logout = async () => {
        await authContext.logout();
        window.location.replace(process.env.REACT_APP_PUBLIC_URL + "/logout");
    }

    return (
        <div className="tableWrapper">
            <div className="row p-l-0 p-20-header">
                <div className="col-md-12">
                    <table>
                        <tbody>

                        <tr>
                            <td>
                                <LogoHp appearance="multicolor" size={40}/>
                            </td>
                            <td>
                                <h4 className="hp-account">HP Supply Encoding Service
                                                <br/>
                                                Account Management</h4>

                            </td>
                                </tr>
                                </tbody>

                            </table>
                            <div>
                                <p className="email">{authContext.userEmail}</p>
                            </div>
                            <div>
                                <button className="btn-signout" onClick={ e => logout(e)}><p className="pright account-signout">Sign out</p></button>
                            </div>
                        </div>
                    </div>
                </div>
    )
  }

export default Headeraccount;
